<div class="counter-container">
  <div class="hidden-value">{{ value }}</div>
  <div class="counter" [class.sliding]="values.length > 1" [class.reverse]="values[0]?.value === value">
    @for (v of values; track v.id) {
      <div class="counter-item" [class.active]="v.value === value">
        {{ v.value }}
      </div>
    }
  </div>
</div>
